// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui-scale-control[data-v-a84b653e] {
  position: fixed;
  right: 4px;
  bottom: 4px;
  z-index: 1001;
  display: flex;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.6);
  opacity: 0.6;
}
.ui-scale-control[data-v-a84b653e]:hover,
.ui-scale-control[data-v-a84b653e]:focus-within {
  opacity: 1;
}
.ui-scale-control button[data-v-a84b653e] {
  min-width: 30px;
  height: 28px;
  padding: 0 6px;
  border: 0;
  background: none;
  color: #eee;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}
.ui-scale-control button[data-v-a84b653e]:disabled {
  color: #666;
  cursor: default;
}
.ui-scale-control .ui-scale-control__value[data-v-a84b653e] {
  font-size: 12px;
  font-weight: normal;
}
`, "",{"version":3,"sources":["webpack://./src/client/components/UiScaleControl.vue","webpack://./UiScaleControl.vue"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,YAAA;ACDF;ADGE;;EACE,UAAA;ACAJ;ADXA;EAeI,eAAA;EACA,YAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;ACDJ;ADGI;EACE,WAAA;EACA,eAAA;ACDN;AD1BA;EAgCI,eAAA;EACA,mBAAA;ACHJ","sourcesContent":["@import \"variables.less\"; @import \"mixins.less\";\n\n.ui-scale-control {\n  position: fixed;\n  right: 4px;\n  bottom: 4px;\n  z-index: 1001;\n  display: flex;\n  border-radius: 8px;\n  background: rgba(0, 0, 0, 0.6);\n  opacity: 0.6;\n\n  &:hover, &:focus-within {\n    opacity: 1;\n  }\n\n  button {\n    min-width: 30px;\n    height: 28px;\n    padding: 0 6px;\n    border: 0;\n    background: none;\n    color: #eee;\n    font-size: 14px;\n    font-weight: bold;\n    cursor: pointer;\n\n    &:disabled {\n      color: #666;\n      cursor: default;\n    }\n  }\n\n  .ui-scale-control__value {\n    font-size: 12px;\n    font-weight: normal;\n  }\n}\n",".ui-scale-control {\n  position: fixed;\n  right: 4px;\n  bottom: 4px;\n  z-index: 1001;\n  display: flex;\n  border-radius: 8px;\n  background: rgba(0, 0, 0, 0.6);\n  opacity: 0.6;\n}\n.ui-scale-control:hover,\n.ui-scale-control:focus-within {\n  opacity: 1;\n}\n.ui-scale-control button {\n  min-width: 30px;\n  height: 28px;\n  padding: 0 6px;\n  border: 0;\n  background: none;\n  color: #eee;\n  font-size: 14px;\n  font-weight: bold;\n  cursor: pointer;\n}\n.ui-scale-control button:disabled {\n  color: #666;\n  cursor: default;\n}\n.ui-scale-control .ui-scale-control__value {\n  font-size: 12px;\n  font-weight: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
